<template>
    <table class="c-products-table">
        <tbody v-for="(product, index) in products">
        <tr>
            <td>
                <img v-if="product.Thumbnail" class="u-no-max-width" :src="product.Thumbnail.replace('[WIDTH]', 160).replace('[HEIGHT]', 100)" width="80" height="50" :alt="product.Title">
                <img v-else src="@/assets/images/no_image.png" width="80" alt="">
            </td>
            <td>
                <span class="u-font-weight-medium u-font-small">{{ product.Name }}</span>
                <span v-if="product.Model" class="u-font-extra-small"><br>{{ product.Model }}</span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.size.label') }}</span>
                <span v-if="product.Size"><br>{{ product.Size }}</span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.color.label') }}</span>
                <span v-if="product.Color">
                    <br>
                    <div v-if="product.ColorHex" class="c-product-color-element" v-bind:style="{ backgroundColor: product.ColorHex}"></div>
                    <span v-if="product.Color" style="position: relative; top: -8px; font-size: 13px;">{{ product.Color }}</span>
                </span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.unit_price.label') }}</span>
                <span v-if="product.ProductPrice" class="u-text-no-wrap"><br>{{ product.ProductPrice | currency(customerCurrencySymbol) }}</span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.quantity.label') }}</span>
                <span v-if="product.Amount" class="u-text-no-wrap"><br>{{ product.Amount }}</span>
            </td>
            <td>
                <span class="u-text-uppercase u-font-weight-medium u-font-extra-tiny">{{ $t('customer.account.backorders.total_price.label') }}</span>
                <span v-if="product.ProductTotal" class="u-text-no-wrap"><br>{{ product.ProductTotal | currency(customerCurrencySymbol) }}</span>
            </td>
        </tr>        

        <tr v-if="index !== products.length - 1">
            <td colspan="7">
                <hr class="c-products-table__hr">
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: ['products'],
        methods: { },
        computed: {
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-products-table {
        @include rfs(16);

        th,
        td {
            vertical-align: top;
            padding: 10px;
        }

        &__hr {
            margin: 0 -15px;
            border: none;
            border-bottom: dashed 1px rgba(#9B9B9B, .5);

            .c-products-table__bar + tr &{
                margin-top: 15px;
            }
        }

    }

    .c-product-color-element {
        width: 30px;
        height: 30px;
        margin-right: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/basket/ProductsTable.vue